import React, {Component} from "react";
import PropTypes from "prop-types";
import Markdown from "react-markdown";
import Column from "./../../../../components/column/column";
import Row from "./../../../../components/row/row";
import OmniChannelDiagram from "./../../../../components/ominiChannelDiagram/omniChannelDiagram";
import valueSectionStyles from "./valueSection.module.pcss";

const ValueSection = ({valueSectionHeadline, valueSectionDescription, valueSectionFunctionality}) => {

  return (
    <Row rowWrapperClassName={valueSectionStyles.valueSection}
         rowContainerClassName={valueSectionStyles.valueSectionContainer}>
      <Column customColumnClass={valueSectionStyles.column}>
        <OmniChannelDiagram
          backgroundColor="#1d2227"
          borderWidth="1%"
          grudLogoColor="white"
          grudLogoWidth="30%"
          circleColor={["#2399dd", "#51e4c0"]}
        />
      </Column>
      <Column customColumnClass={valueSectionStyles.column}>
        <div className={valueSectionStyles.columnWrapper}>
          <Markdown source={valueSectionHeadline} />
          <Markdown source={valueSectionDescription} />
          <Markdown source={valueSectionFunctionality} />
        </div>
      </Column>
    </Row>
  )
};

ValueSection.propTypes = {
  valueSectionHeadline: PropTypes.string.isRequired,
  valueSectionDescription: PropTypes.string.isRequired,
  valueSectionFunctionality: PropTypes.string.isRequired
};

export default ValueSection;


// WEBPACK FOOTER //
// ./src/templates/landing/components/valueSection/valueSection.js